import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/common/Card';
import { ProjectForm } from '../components/ProjectForm';
import { useToast } from '../contexts/ToastContext';
import { api } from '../lib/api';

export function SubmitPage() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: { title: string; description: string }) => {
    setIsSubmitting(true);
    try {
      const response = await api.submitProject(data);
      showToast('Idea submitted successfully!', 'success');
      navigate(`/project/${response.project_id}`);
    } catch (error) {
      console.error('Submit error:', error);
      showToast('Failed to submit idea. Please try again.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-wolf-100 mb-2">Submit an Idea</h1>
        <p className="text-wolf-300">
          Share your R&D project idea for AI-powered evaluation against our strategic framework.
        </p>
      </div>

      <Card>
        <ProjectForm
          submitLabel="Submit Idea"
          cancelTo="/dashboard"
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
        />
      </Card>
    </div>
  );
}
